<!-- eslint-disable vuejs-accessibility/mouse-events-have-key-events -->
<template>
  <SubmenuDropdown
    :close-on-click="true"
    class="dropdown-icon"
    round
    @mouseenter="$emit('tracking-event', {
      action: 'navDropdownHover',
      args: { label: 'Analytics' },
    })"
  >
    <div class="icon-text-pair">
      <router-link
        :to="{
          name: 'recruiting-performance',
          query: getReportingQueryParam('recruiting-performance'),
        }"
      >
        <DpplSvg file-name="icon-analytics" />
        <span class="ml-2">
          Insights
        </span>
      </router-link>
    </div>
    <NavigationMenu
      :columns="3"
      :link-sections="reportingNavLinks"
      :get-query-param="getReportingQueryParam"
      @tracking-event="(params) => $emit('tracking-event', params)"
    />
  </SubmenuDropdown>
</template>

<script>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import SubmenuDropdown from '@/components/editor/SubmenuDropdown.vue';
import { getReportingQueryParam } from '@/api/helpers/insights/insights';
import NavigationMenu from '@/components/shared/NavigationMenu.vue';

export default {
  name: 'InsightsNavigationDropdown',
  components: {
    DpplSvg,
    NavigationMenu,
    SubmenuDropdown,
  },
  props: {
    reportingNavLinks: { type: Array, default: () => [] },
  },
  emits: ['tracking-event'],
  methods: {
    getReportingQueryParam(routeName) {
      return getReportingQueryParam(this.$route, routeName);
    },
  },
};
</script>
<style scoped lang="less">
.icon-text-pair a {
  display: flex;
  align-items: center;
  position: relative;
  span {
    font-size: 15px;
    font-weight: 500;
  }
}

.new-insights-icon {
  position: absolute;
  right: -20px;
  top: 0px;
  width: 28px;
  height: 17px;
  border-radius: 20px;
  background: @white;
  color: @text-brand;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  font-weight: 400;
  line-height: 9.5px;
}
</style>
